import { useEffect } from 'react';
import { LuFileText, LuGitCompare, LuPenLine } from 'react-icons/lu';

import { useCopilot } from '../CopilotContext';
import { ChatPanel } from '../chat/ChatPanel/ChatPanel';
import { Composer } from '../chat/Composer/Composer';
import { ListeningIndicator } from '../chat/ListeningIndicator/ListeningIndicator';
import { Suggestions } from '../chat/Suggestions/Suggestions';
import { TypingIndicator } from '../chat/TypingIndicator/TypingIndicator';
import { ScanProgressStrip } from '../ScanProgressStrip/ScanProgressStrip';

import styles from './CopilotPopoutView.module.css';

const SUGGESTIONS = [
  { id: 'summarize', label: 'Summarize this study', icon: LuFileText },
  { id: 'compare', label: 'Compare with the prior', icon: LuGitCompare },
  { id: 'draft', label: 'Draft the conclusion', icon: LuPenLine },
] as const;

const SUGGESTION_PROMPTS: Record<string, string> = {
  summarize:
    'Give me a quick summary of this study — the key measurements and anything out of range.',
  compare:
    'How does this study compare to the most recent prior for this patient?',
  draft:
    'Help me draft the conclusion for this study from the measurements and AI findings.',
};

export function CopilotPopoutView() {
  const { open, messages, sendText, isLoadingMessages } = useCopilot();

  // The popout is effectively "always open" — force the context open on mount
  // so the WS connects.
  useEffect(() => {
    open();
  }, [open]);

  const hasMessages = messages.length > 0;
  const showChatPanel = hasMessages || isLoadingMessages;

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <span className={styles.title}>ECHOGPT</span>
      </header>

      <div className={styles.body}>
        <div className={styles.scroll}>
          {!showChatPanel && (
            <>
              <div className={styles.greeting}>Hi, how can I help?</div>
              <Suggestions
                items={SUGGESTIONS}
                onPick={(id) => sendText(SUGGESTION_PROMPTS[id])}
              />
              <p className={styles.disclaimer}>
                Responses are AI-generated and for clinical reference only.
                Always verify before use.
              </p>
            </>
          )}

          {showChatPanel && <ChatPanel />}
        </div>

        <ScanProgressStrip />

        <TypingIndicator />

        <ListeningIndicator />

        <div className={styles.composer}>
          <Composer />
        </div>
      </div>
    </div>
  );
}
